import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from "../variants";

const Contact = () => {
  return (
        <section className='py-16 pb-[500px] lg:section' id='contact'>
          <div className="container mx-auto">
            <div className="flex flex-col justify-center items-center lg:flex-row">
              <motion.div
              variants={fadeIn('right', 0.3)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3}}
              className="flex lg:w-[48%] w-[100%]"
              >
                <div>
                  <h4 className='text-xl uppercase text-accent font-medium mb-2 tracking-wide'>Get in touch</h4>
                  <h2 className='text-[45px] lg:text-[90px] leading-none mb-12'>
                    Let's work <br/> together!
                  </h2>
                </div>
              </motion.div>
              <motion.div 
              variants={fadeIn('left', 0.3)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3}}
              className='flex flex-col justify-center gap-y-[3rem] lg:w-[48%] w-[100%]'>
                  <div className='w-full h-[55px] relative flex items-center pl-[25px] border-solid border-2 border-indigo-600'>
                    <span className='absolute top-[-18px] left-[22px] text-[1.5rem] text-white font-bold px-[8px] bg-[#22134A] tracking-[0.4px]'>Email</span>
                    <a href="mailto:sincodesoffical@gmail.com" className='text-accent overflow-hidden text-[1.2rem] mt-[5px] font-bold tracking-[0.4px] duration-300 hover:opacity-80 hover:duration-300'>sincodesoffical@gmail.com</a>
                  </div>
                  <div className='w-full h-[55px] relative flex items-center pl-[25px] border-solid border-2 border-indigo-600'>
                    <span className='absolute top-[-18px] left-[22px] text-[1.5rem] text-white font-bold px-[8px] bg-[#22134A] tracking-[0.4px]'>Telegram</span>
                    <a href="https://t.me/SinCode" className='text-accent overflow-hidden text-[1.2rem] font-bold tracking-[0.4px] mt-[5px] duration-300 hover:opacity-80 hover:duration-300' target="_blank">@SinCode</a>
                  </div>
                  <div className='w-full h-[55px] relative flex items-center pl-[25px] border-solid border-2 border-indigo-600'>
                    <span className='absolute top-[-18px] left-[22px] text-[1.5rem] text-white font-bold px-[8px] bg-[#22134A] tracking-[0.4px]'>Freelance Habr</span>
                    <a href="https://freelance.habr.com/freelancers/SinCode" className='text-accent overflow-hidden text-[1.2rem] mt-[5px] font-bold tracking-[0.4px] duration-300 hover:opacity-80 hover:duration-300' target="_blank">https://freelance.habr.com/freelancers/SinCode</a>
                  </div>
              </motion.div>
            </div>
          </div>
        </section>
    )
};

export default Contact;
